// frontend/src/landing/sections/HeroSection.tsx
import HeroChecklist from "../components/HeroChecklist";
import ScreenshotSlideshow from "../components/ScreenshotSlideshow";

import s1Dark from "../assets/01-screenshot-dark.webp";
import s1Light from "../assets/01-screenshot-light.webp";
import s6Dark from "../assets/06-screenshot-dark.webp";
import s6Light from "../assets/06-screenshot-light.webp";
import s8Dark from "../assets/08-screenshot-dark.webp";
import s8Light from "../assets/08-screenshot-light.webp";
import animationMp4Dark from "../assets/zeitgeist-animation-dark.mp4";
import animationMp4Light from "../assets/zeitgeist-animation-light.mp4";

const slides = [
  { id: "s1", title: "Legen Sie einfach direkt los", caption: "kein Installieren, kein Handbuch-Wälzen", kind: "image" as const, lightSrc: s1Light, darkSrc: s1Dark, alt: "App" },
  { id: "s6", title: "Ihre ganz persönliche Was-Wäre-Wenn Maschine", caption: "keine abstrakten Zahlenwerte und Schieberegler mehr", kind: "image" as const, lightSrc: s6Light, darkSrc: s6Dark, alt: "Priorität" },
  { id: "s8", title: "Sprechen Sie doch einfach mit uns", caption: "Mal ehrlich: kennen Sie ein anderes Planungsprogramm, das das kann?", kind: "image" as const, lightSrc: s8Light, darkSrc: s8Dark, alt: "KI" },
  {
    id: "anim",
    kind: "video" as const,
    title: "So fühlt sich Planung heute an",
    caption: "fair, flexibel, flink",
    mp4LightSrc: animationMp4Light,
    mp4DarkSrc: animationMp4Dark,
    alt: "Animation",
  },
];

export type HeroSectionProps = {
  onSignup: () => void;
  onLogin: () => void;
};

export default function HeroSection(_props: HeroSectionProps) {
  return (
    <section className="zg-hero">
      <div className="zg-container">
        <div className="zg-hero-grid">
          <div className="zg-hero-copy">
            <h1 className="zg-h1">zeitgeist</h1>
            <h2 className="zg-h2">fair, flexibel, flink</h2>
              <HeroChecklist
                items={[
                  { id: "r", text: "Regeln geklärt." },
                  { id: "p", text: "Prioritäten festgelegt." },
                  { id: "b", text: "Plan entsteht." },
                ]}
              />
          </div>

          <div className="zg-hero-media">
            <div className="zg-hero-media-inner">
              <ScreenshotSlideshow slides={slides} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}